var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.axisNames && _vm.axisValues)?_c('div',{staticClass:"line-plot-wrapper"},[_c('div',{ref:this.uuid,staticClass:"peaks-plot"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }